import React from 'react';
import { ModalWindow } from 'src/components/modal-window/modal-window';
import { TooManyAttempts2fa } from 'src/components/too-many-attempts-2fa/too-many-attempts-2fa';
import { MODAL_IDS } from 'src/constants';

import './too-many-attempts-2fa-modal.scss';

export const TooManyAttempts2faModal = () => (
  <ModalWindow
    id={MODAL_IDS.TOO_MANY_ATTEMPTS_2FA}
    coreProps={{ id: MODAL_IDS.TOO_MANY_ATTEMPTS_2FA }}
    bodyClassName="py-4 px-2"
    className="too-many-attempts-2fa-modal"
    fade
  >
    <TooManyAttempts2fa />
  </ModalWindow>
);
